function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-.001 0h24v24h-24z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M10.098 6L8.683 7.41 13.28 12l-4.597 4.59L10.098 18l6.023-6z"
}));

var SvgIcChevronRight = function SvgIcChevronRight(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0uOTQpIj4KICAgIDxwb2x5Z29uIHBvaW50cz0iLjkzOSAwIDI0LjkzOSAwIDI0LjkzOSAyNCAuOTM5IDI0Ii8+CiAgICA8cG9seWdvbiBmaWxsPSIjRkZGIiBwb2ludHM9IjExLjAzOCA2IDkuNjIzIDcuNDEgMTQuMjIgMTIgOS42MjMgMTYuNTkgMTEuMDM4IDE4IDE3LjA2MSAxMiIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgIcChevronRight as ReactComponent };